module.exports = __webpack_public_path__ + "rapid-prototyping-design.37XYTMXt.svg";